import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import moment from "moment-timezone";
import { Negociacao } from "../models/enum";
import { NotaBMF, NotaBovespa } from "../models/nota";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class NotaDb extends BaseDb<
  NotaBovespa | NotaBMF,
  { usuarioId: string; notaId: string }
> {
  _path: string = "usuarios/usuarioId/notas/notaId";
  getConverter(): FirestoreDataConverter<NotaBovespa | NotaBMF> {
    return {
      fromFirestore: (snapshot): NotaBovespa | NotaBMF => {
        if (snapshot.get("tipoNegociacao") === Negociacao.BOVESPA) {
          return new NotaBovespa({
            id: snapshot.id,
            upload: snapshot.get("upload"),
            usuario: snapshot.get("usuario"),
            dataPregao: moment.tz(
              snapshot.get("dataPregao").toDate(),
              "America/Sao_Paulo"
            ),
            situacao: snapshot.get("situacao"),
            erro: snapshot.get("erro"),
            corretora: snapshot.get("corretora"),
            numeroNota: snapshot.get("numeroNota"),
            taxaLiquidacao: snapshot.get("taxaLiquidacao"),
            emolumentos: snapshot.get("emolumentos"),
            corretagem: snapshot.get("corretagem"),
            tipoNegociacao: snapshot.get("tipoNegociacao"),
            quantidadeOperacoes: snapshot.get("quantidadeOperacoes"),
            valorLiquido: snapshot.get("valorLiquido"),
            taxaRegistro: snapshot.get("taxaRegistro"),
            iss: snapshot.get("iss"),
            irrf: snapshot.get("irrf"),
            outrosCustos: snapshot.get("outrosCustos"),
          });
        } else {
          return new NotaBMF({
            id: snapshot.id,
            upload: snapshot.get("upload"),
            usuario: snapshot.get("usuario"),
            dataPregao: moment.tz(
              snapshot.get("dataPregao").toDate(),
              "America/Sao_Paulo"
            ),
            situacao: snapshot.get("situacao"),
            erro: snapshot.get("erro"),
            corretora: snapshot.get("corretora"),
            numeroNota: snapshot.get("numeroNota"),
            irrfDaytrade: snapshot.get("irrfDaytrade"),
            taxaOperacional: snapshot.get("taxaOperacional"),
            taxasBmf: snapshot.get("taxasBmf"),
            outros: snapshot.get("outros"),
            tipoNegociacao: snapshot.get("tipoNegociacao"),
            quantidadeOperacoes: snapshot.get("quantidadeOperacoes"),
            valorLiquido: snapshot.get("valorLiquido"),
            taxaRegistro: snapshot.get("taxaRegistro"),
            iss: snapshot.get("iss"),
            irrf: snapshot.get("irrf"),
            outrosCustos: snapshot.get("outrosCustos"),
          });
        }
      },
      toFirestore: (nota: NotaBovespa | NotaBMF) =>
        toFirestore(omit(nota, ["id"])),
    };
  }
}
